import { RouteContentSkeleton, RouteSkeleton } from '../siop/SiopSkeletons';

const RouteFallback = ({ contentOnly = false }) =>
  contentOnly ? <RouteContentSkeleton /> : <RouteSkeleton />;

export default RouteFallback;
